import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Axios from 'axios';
import { API } from '../api/api';
import './../css/auth.scss';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ClipLoader from 'react-spinners/ClipLoader';
import { useHistory } from 'react-router';
import { TextInput } from '../components/TextInput';
import { loginFailed, loginPopUp, loginSuccess, setUserProp, viewPrivacyPolicy } from '../services/amplitude';
import { createErrorMsg, setLocalstorageLogin } from '../helper';
import useShowPassword from '../hooks/useShowPassword';
import { showLoginSuccess } from '../utils/bootstrapUI';
import { requestLoginSuccess } from '../utils/auth';

export const LoginModal = ({ pageChannel }) => {
  const MySwal = withReactContent(Swal);
  const history = useHistory();

  const [login, setLogin] = useState({
    email: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);
  const { currentPage } = useSelector((state) => state.amplitude);
  const { day_left } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'SET_CURRENT_PAGE', payload: pageChannel });
    if (pageChannel && pageChannel !== 'Overview' && day_left === null) {
      loginPopUp(pageChannel);
    }
  }, [pageChannel]);

  const onLogin = () => {
    if (login.email !== '' && login.password !== '') {
      setLoading(true);
      Axios.post(API.login, {
        username: login.email,
        password: login.password,
      })
        .then((res) => {
          setLoading(false);

          if (res.data.status !== 1) {
            throw res
          }

          requestLoginSuccess(res.data.data)
          showLoginSuccess()

          localStorage.setItem('login_with', 'api')
          window.location.reload()
        })
        .catch((err) => {
          setLoading(false);
          loginFailed(err.response && createErrorMsg(err.response.status), 'email', login.email, currentPage);
          MySwal.fire({
            title: 'Maaf',
            icon: 'info',
            text: err.response
              ? createErrorMsg(err.response.status)
              : 'Terjadi kesalahan, periksa jaringan internet anda dan coba lagi.',
          });
        });
    }
  };

  const { onShowPassword, showPassword } = useShowPassword({
    typePassword: 'password',
    typePasswordConfirm: 'password_confirm',
  });

  const [error, setError] = useState({
    email: false,
    password: false,
  });

  const onChange = (event) => {
    if (event.target.name == 'email') {
      setLogin({ ...login, email: event.target.value });
      event.target.value == '' ? setError({ ...error, email: true }) : setError({ ...error, email: false });
    } else if (event.target.name == 'password') {
      setLogin({ ...login, password: event.target.value });
      event.target.value == '' ? setError({ ...error, password: true }) : setError({ ...error, password: false });
    }
  };

  return (
    <div
      className="modal fade"
      data-keyboard="false"
      data-backdrop="static"
      id="modal-login"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md" style={{ width: '96.5vw' }} role="document">
        <div className="modal-content px-3">
          <div className="d-flex justify-content-end pt-3 pr-3 text-danger">
            <button
              data-dismiss="modal"
              onClick={() => {
                history.replace({ pathname: '/', state: { pageChannel: currentPage } });
              }}
              style={{
                borderRadius: '50%',
                width: 25,
                height: 25,
                outline: 'none',
                border: 'none',
                backgroundColor: 'red',
                color: 'white',
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          {!loading ? (
            <div className="modal-body text-center">
              <h4>Masuk Dengan Akun Anda</h4>
              <label className="float-left mb-1 mt-3">Email</label>

              <TextInput
                placeholder="Masukan Alamat Email Anda"
                error={error.email}
                value={login.email}
                onChange={(event) => {
                  onChange(event);
                }}
                name="email"
                type="email"
              />
              <label className="float-left mb-1 mt-3">Kata Sandi</label>

              <TextInput
                placeholder="Masukan Kata Sandi Anda"
                error={error.password}
                value={login.password}
                onChange={(event) => {
                  onChange(event);
                }}
                name="password"
                type="password"
                show={showPassword.password}
                onShow={onShowPassword}
              />
              <div className="row">
                <div className="col-md-12">
                  <div className="form-check float-left mt-3">
                    <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                    <label className="form-check-label ml-2">Ingat Saya</label>
                  </div>
                </div>
              </div>
              <p className="terms-condition">
                Anda telah mengetahui dan menyetujui{' '}
                <a href="/syarat-ketentuan" onClick={() => viewPrivacyPolicy()}>
                  Syarat & Ketentuan
                </a>{' '}
                dari IBID MAP
              </p>
              <div className="row mt-3">
                <div className="col-md-12">
                  <button
                    type="button"
                    onClick={onLogin}
                    className="btn w-100"
                    style={{ backgroundColor: '#82be2a', color: 'white' }}
                  >
                    Masuk
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p className="text-center mt-4">
                    Belum punya akun ?
                    <a href="/register" className="ml-1" style={{ color: '#82be2a' }}>
                      Daftar di sini
                    </a>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="modal-body text-center" style={{ height: '30vh' }}>
              <ClipLoader loading size={50} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
